import masthead from "../assests/HPE/enterpriseone/smb-a/webp/masthead-smb-a.webp";
import zertoMaster from "../assests/HPE/enterpriseone/smb-a/webp/benefits.webp";
import clockIcon from "../assests/HPE/enterpriseone/ent-a/icons/clock.svg";
import arrowRightIcon from "../assests/HPE/enterpriseone/ent-a/icons/arrow-right.svg";
import userIcon from "../assests/HPE/enterpriseone/ent-a/icons/user.svg";
import number1 from "../assests/HPE/enterpriseone/smb-a/numbers-1.svg";
import number2 from "../assests/HPE/enterpriseone/smb-a/numbers-2.svg";
import shield from "../assests/HPE/enterpriseone/smb-a/shield.svg";
import number3 from "../assests/HPE/enterpriseone/smb-a/database-check.svg";
import Input from "../components/common/Input";
import HilightCard from "../components/ui/enterprise1/HilightCard";
import benefitCard1 from "../assests/HPE/enterpriseone/ent-a/webp/benefits-1.webp";
import benefitCard2 from "../assests/HPE/enterpriseone/ent-a/webp/benefits-2.webp";
import caseStudy from "../assests/HPE/enterpriseone/ent-a/webp/case-study.webp";
import astra from "../assests/HPE/enterpriseone/ent-a/png/astra.png";
import StatsCard from "../components/ui/enterprise1/StatsCard";
import EnterpriseInput from "../components/ui/enterprise1/EnterpriseInput";
import { useState } from "react";
import EnterpriseHeader from "../components/ui/enterprise1/EnterpriseHeader";
import ZertoHighlightCard from "../components/ui/zerto/ZertoHighlightCard";
import ZertoFeatureCard from "../components/ui/zerto/ZertoFeatureCard";
import BeforeAfterCard from "../components/ui/zerto/BeforeAfterCard";
import ZertoResourcesForm from "../components/ui/zerto/ZertoResoucesForm";
import StackedDocuments from "../components/ui/enterprise1/StackedDocuments";
import ZertoStackedDocuments from "../components/ui/zerto/ZertoStckedDocument";
import EnterpriseFooter from "../components/ui/enterprise1/EnterpriseFooter";
import Layout from "../components/layout/Layout";
import { useTrackEvent } from "../hooks/useTrackEvent";
const ZertoOne = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState(false);
  const trackEvent = useTrackEvent();

  const handleFullNameFocus = () => {
    trackEvent(
      {
        event: "form_start",
        form_location: "hero",
        statsig_design_id: "zerto-1",
      },
      { once: true },
    );
  };

  function handleOpenPopup() {
    if (!fullName.trim()) {
      setFullNameError(true);
      return;
    }
    setFullNameError(false);
    setShowPopup(true);
    trackEvent(
      {
        event: "form_continue",
        form_location: "hero",
        statsig_design_id: "zerto-1",
      },
      { once: true },
    );
  }

  const beforeData = [
    {
      value: "12 hours",
      description: "of potential data loss",
    },
    {
      value: "2 weeks",
      description: "to full recovery",
    },
  ];
  const afterData = [
    {
      value: "10 seconds",
      description: "of data loss",
    },
    {
      value: "<10 min",
      description: "to full recovery",
    },
  ];
  return (
    <Layout title="HPE Zerto Software" variant="enterprise">
      <div className="w-full min-h-screen ">
        {/* <div className="w-full bg-green-04  pt-5 md:pb-16 pb-4 flex justify-center">
        <EnterpriseHeader />
      </div> */}
        {/** 1 */}
        <div className="w-full bg-green-04 pb-24">
          <div className="flex flex-col max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto md:flex-row gap-6 md:gap-10 ">
            {/* LEFT SECTION */}
            <div className="flex flex-col gap-10 md:gap-16 w-full lg:w-1/2 lg:min-w-[450px]">
              {/* TEXT (TOP) */}
              <div className="order-1 md:order-none flex flex-col gap-6 md:max-w-[450px]">
                <p className=" text-grey-02 font-medium text-[22px]/[28px] font-google md:text-[36px]/[44px] self-stretch">
                  If <span className="text-red">ransomware hit</span> tonight,{" "}
                  <span className="text-red">how long</span> would recovery take
                  and {""}
                  <span className="text-red">how much</span> data would be gone?
                </p>

                <p className="text-grey-04 md:text-4/6 text-3/[18px] font-inter">
                  <b className="text-grey-03 font-semibold">HPE Zerto</b>{" "}
                  recovers in under 60 seconds with near zero data loss. Take
                  the 2-minute resilience check and get the free technical
                  whitepaper.
                </p>
              </div>

              {/* IMAGE (MOBILE ONLY - BETWEEN) */}
              <div className="order-2 md:hidden w-full flex">
                <div className="relative w-full md:max-w-[553px]">
                  <img
                    src={masthead}
                    alt=""
                    className="w-full h-auto rounded-[8px]"
                  />
                </div>
              </div>

              {/* FORM (BOTTOM) */}
              <div className="order-3 md:order-none flex w-full md:min-w-[400px] md:max-w-[400px] flex-col gap-6">
                {/* STEP */}
                <span className="text-white py-0.5 px-3 font-google rounded-3xl bg-navy-blue-03 w-fit text-2/[22px] font-medium">
                  STEP 1 / 2
                </span>

                {/* INPUT */}
                <div className="flex flex-col gap-4">
                  <div className="flex gap-4">
                    <div className="flex-1 flex flex-col gap-1">
                      <EnterpriseInput
                        placeholder="Full name*"
                        theme="zerto"
                        variant="dark"
                        className="flex-1"
                        icon={userIcon}
                        inputClassName="text-white text-[14px]/[22px] font-medium h-[46px]"
                        iconClassName="w-5 h-5"
                        value={fullName}
                        onFocus={handleFullNameFocus}
                        onChange={(e) => {
                          setFullName(e.target.value);
                          if (e.target.value.trim()) {
                            setFullNameError(false);
                          }
                        }}
                        error={
                          fullNameError ? "Please enter your full name" : ""
                        }
                      />
                    </div>

                    <div
                      onClick={handleOpenPopup}
                      className="flex h-[46px] px-4 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 items-center justify-center cursor-pointer"
                    >
                      <img
                        src={arrowRightIcon}
                        className="w-[18px] h-[18px]"
                        alt=""
                      />
                    </div>
                  </div>

                  {/* INFO */}
                  <div className="flex items-center gap-2">
                    <img src={clockIcon} className="w-[14px] h-[14px]" alt="" />
                    <p className="text-grey-03 font-normal text-[10px]/[18px] md:text-[12px]/[20px] font-inter">
                      <span className="text-green font-medium">
                        Takes 30 seconds.
                      </span>{" "}
                      Resource pack downloads instantly after.
                    </p>
                  </div>
                </div>

                {/* DIVIDER */}
                <div className="w-full h-[1px] border-white/10 border-dashed border-t" />

                {/* ZIP CARD */}

                <ZertoStackedDocuments />

                {/* <DocumentPreview/> */}
              </div>
            </div>

            {/* RIGHT IMAGE (DESKTOP ONLY) */}
            <div className="hidden md:flex w-full lg:w-1/2 justify-end">
              <div className="relative w-full md:max-w-[553px]">
                <img
                  src={masthead}
                  alt=""
                  className="w-full h-auto rounded-[8px]"
                />
              </div>
            </div>
          </div>
        </div>

        {/** 2 */}

        <div className="w-full bg-green-03">
          <div
            className="
                flex flex-col md:flex-row max-w-[1188px]
                mx-auto
                py-12 md:py-20
                px-4 sm:px-6 md:px-10
                gap-6 md:gap-10
                items-start md:items-center
                bg-green-03"
          >
            <StatsCard
              title="<60s"
              description="Recovery time objective"
              image={number1}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="~0"
              description="Data loss with continuous replication"
              image={number3}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="3-in-1"
              description="DR, backup and ransomware in one platform"
              image={number2}
            />
          </div>
        </div>
        {/* </div> */}
        {/** 3 */}
        {/* <div className="flex flex-col justify-center items-center container mx-auto w-full gap-[80px] mt-[120px]  m-auto mb-[80px]"> */}
        <div className="w-full max-w-[1188px] mx-auto md:mt-[120px] mt-20 mb-[80px] px-4 sm:px-6 md:px-10 flex flex-col gap-[80px]">
          {/* <div className=" container mx-auto"> */}
          <p className="text-grey-06 text-[20px] leading-[32px] text-start md:text-[32px] font-google font-style:normal md:leading-[48px] font-medium">
            Most backup tools protect to the last scheduled snapshot. If{" "}
            <span className="text-red">ransomware encrypts data </span>for 8
            hours before detection, that is 8 hours of data gone and{" "}
            <span className="text-red">potentially weeks of recovery</span>{" "}
            ahead. Traditional backup was not designed for ransomware.
            <span className="text-blue"> Zerto was</span>.
          </p>
          {/* </div> */}
          <div className="flex flex-col items-start gap-12 md:inline-flex md:w-auto md:flex-row md:items-center md:gap-6">
            <ZertoHighlightCard
              badge="CAPABILITY"
              image={zertoMaster}
              // title="Stop paying VMware tax"
              // description="Run VMware and KVM side by side on existing infrastructure. No forced migration. Per-socket pricing at a fraction of Broadcom charges."
            />
          </div>
          <div className="flex flex-col md:flex-row md:items-start w-full items-start gap-6">
            <ZertoFeatureCard
              image={number3}
              title="Continuous data protection"
              description="Every write to disk replicated in near real time. Recovery point always seconds old. When ransomware strikes, there is almost nothing to lose."
            />
            <ZertoFeatureCard
              image={shield}
              title="Real time ransomware detection"
              description="Monitors encryption patterns at block level. Detects anomalous activity before attackers can spread laterally across systems."
            />
            <ZertoFeatureCard
              image={number1}
              title="Recover in under 60 seconds"
              description="Surgical rollback to a clean recovery point before encryption started. No ransom. No extended downtime. No manual restoration."
            />
          </div>

          <div className="w-full">
            {/* <div className="flex flex-col md:flex-row rounded-[16px] overflow-hidden">

          </div> */}
            <div className="w-full">
              <div className="flex flex-col md:flex-row rounded-[16px] overflow-hidden">
                {/* BEFORE */}
                <BeforeAfterCard
                  label="TENCATE"
                  title="BEFORE ZERTO"
                  items={beforeData}
                  variant="before"
                />

                {/* AFTER */}
                <BeforeAfterCard
                  title="AFTER ZERTO"
                  items={afterData}
                  variant="after"
                />
              </div>
            </div>
          </div>
        </div>
        {/** 4 */}
        <ZertoResourcesForm
          showPreview={true}
          isPopup={false}
          showQuestionGroupOne={true}
          showQuestionGroupTwo={false}
          variant="zerto-1"
          formLocation="bottom"
          statsigDesignId="zerto-1"
        />
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
              className="absolute inset-0 bg-black/80"
              onClick={() => setShowPopup(false)}
            />

            <div className="relative w-full max-w-[1100px] z-10 max-h-[90vh] overflow-y-auto">
              <ZertoResourcesForm
                showPreview={true}
                isPopup={true}
                onClose={() => setShowPopup(false)}
                initialFullName={fullName}
                showQuestionGroupOne={true}
                showQuestionGroupTwo={false}
                formLocation="hero"
                statsigDesignId="zerto-1"
              />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default ZertoOne;
